import View from 'ln/view/View';
import Node from 'ln/node/Node';
import ModifiableList from 'ln/list/ModifiableList';

class SearchFilterView extends View {

	private textInput:Node;
	private modifiableList:ModifiableList<any>;
	private searchString;
	private _comparisonAttributes:string[];
	private boundFilter:any;
	
	
	constructor( modifiableList:ModifiableList<any>, template:string = 'krw.courselistfilter-searchfilter' ) {
		super();
		this.modifiableList = modifiableList;
		this.boundFilter = this.filter.bind( this );		
		this.defaultTemplate = template;
	}
	
	public init() {
		this.textInput = this.node.one( 'input' );
		
		this.textInput.blur.add( this.onChange, this );
		this.textInput.change.add( this.onChange, this );
		this.textInput.keyup.add( this.onChange, this );	
	}
	
	private onChange( ) {
		this.searchString = this.textInput.value;

		if( this.searchString == undefined || this.searchString == '' ) {
			this.modifiableList.modifiers.remove( this.boundFilter );
		} else {
			if( !this.modifiableList.modifiers.contains( this.boundFilter ) ) {
				this.modifiableList.modifiers.append( this.boundFilter );
			}
			this.modifiableList.update();
		}
	}
	
	private filter( items:any[] ): any[] {
		var tmpItems:any[] = [];
		
		items.forEach( ( item, index ) => {
			var found = false;			
			this._comparisonAttributes.forEach( ( attr ) => {
				if( item[attr] && Array.isArray( item[attr] ) ){
					
					var searchStr = this.searchString.toLowerCase();
					// search the array for the search-string
					found = item[attr].some( function( str:string ){
						return str.toLowerCase().indexOf( searchStr ) != -1;
					}.bind( this ) );

				} else if( item[attr] && item[attr].toLowerCase().indexOf( this.searchString.toLowerCase() ) != -1  ) {
					found = true;
				}				
			});			
			if( found ) tmpItems.push( item );			
		});
				
		return tmpItems;
	}
	
	set comparisonAttributes( c:string[] ) {
		this._comparisonAttributes = c;
	}
	
	get comparisonAttributes():string[] {
		return this._comparisonAttributes;
	}	
	
}

export default SearchFilterView;